import type { NumericString } from './types';

export const IS_NUMERIC_REGEX = /\p{N}+/gu;

interface ParseOpts {
  decimalSeparator: string;
  minusSign: string;
}

const defaultParseOpts: ParseOpts = {
  decimalSeparator: '.',
  minusSign: '-',
};

export function parseNumber(value: string, opts?: Partial<ParseOpts>): NumericString | '' {
  const { decimalSeparator, minusSign } = {
    ...defaultParseOpts,
    ...opts,
  };

  let isNegative = false;
  let hasSeenDecimal = false;
  let hasSeenDigit = false;

  const out: string[] = [];

  for (let i = 0; i < value.length; i++) {
    const char = value[i];

    if (char >= '0' && char <= '9') {
      out.push(char);
      hasSeenDigit = true;
      continue;
    }

    // minus sign (should happen before numbers)
    if (char === minusSign && !isNegative && !hasSeenDigit) {
      isNegative = true;
      continue;
    }

    // decimal separator
    if (char === decimalSeparator) {
      if (hasSeenDecimal) {
        break;
      }

      hasSeenDecimal = true;
      out.push('.');
    }
  }

  // reject invalid constructs like ".", "-.", ""
  if (!hasSeenDigit) {
    return '';
  }

  const result = out.join('');

  return (isNegative ? `-${result}` : result) as NumericString;
}
